import React from "react";

import { useProductList } from "Pages/ServiceForm/SelectProducts/useProductList";
import { Box } from "styles/globalComponents";

import { useProductCombos } from "Hooks/useProductCombos";

import { Loading } from "Utils/Loading";

import { Pagination } from "Components/Pagination";

import { Button } from "Components/Button";
import { Brain } from "lucide-react";
import { useCreateIABudget } from "Pages/ServiceForm/useCreateIABudget";
import { useBudgetContext } from "Hooks/useBudgetContext";
import { ModalProductsWarning } from "Pages/ServiceForm/ModalsProductsWarning";
import { ModalProductsErrorIA } from "Pages/ServiceForm/ModalProductsErrorIA";
import { Loader } from "Components/Loader";
import { useDispatch } from "react-redux";
import { clearNewTrackingAction } from "Actions/ActionsCreators";
import { clearIABudget } from "Actions/IABudget";
import { BudgetProductsFilter } from "../Filters";
import { ProductsListResult } from "../ProductResultList";
import { ModalUploadFilesIA } from "../ModalUploadFIlesIA";

const combosParams = {
  includeCombo: [
    "categories",
    "subcategories",
    "status",
    "services",
    "partners",
  ],
  searchBudget: true,
};

export const CartSearch = () => {
  const {
    cancelAddProduct,
    handleChangePartner,
    handleConfirmPartnerSelection,
    proceedAddProduct,
    closeModal,
    modal,
    partnersOptions,
    preparation,
    modalProductsFailed,
    openModalIA,
    runningIA,
    setOpenModalIA,
    failedProductsOnAdd,
    setModalProductsFailed,
    handleAddProductsFromFile,
    isAddingProducts,
  } = useCreateIABudget();

  const { isCreatingIABudget, loadingCart, partnerSelected, budget } =
    useBudgetContext();

  const {
    loadingProducts,
    getProducts,
    productsList,
    fetchNewPage,
    pageSelected,
    productsPagination,
    handleClearData,
    filters,
  } = useProductList();

  const { loadingCombos } = useProductCombos(combosParams);

  const dispatch = useDispatch();

  const loadingProductsOrCombo = loadingProducts || loadingCombos;

  const hasItemsAddedWithIA = budget?.cart.some((item) => item.ai);

  const onIAGenerate = () => {
    setOpenModalIA(true);
    dispatch(clearNewTrackingAction());
    dispatch(clearIABudget());
  };

  return (
    <div>
      <Box display="flex" align="center" justify="space-between" mb="20">
        <h5 className="title-search-products-budget">
          Buscar produtos de Exames,Testes e Check-up
        </h5>

        {isCreatingIABudget && (
          <Button
            classButton="btn-action btn-ia"
            onClick={onIAGenerate}
            disabled={hasItemsAddedWithIA}
          >
            <Brain />
            Gerar com IA
          </Button>
        )}
      </Box>

      <BudgetProductsFilter
        getProducts={getProducts}
        fetchNewPage={fetchNewPage}
        clearFetchedData={handleClearData}
      />

      {loadingProductsOrCombo ? (
        <Box mt="30">
          <Loading />
        </Box>
      ) : (
        <div className="cart-flex-products">
          {filters.services?.length >= 1 &&
            !productsList &&
            !loadingProducts && (
              <p className="text-danger text-display text-center text-no-margin">
                Oops! Nenhum produto encontrado...
              </p>
            )}

          {!loadingProductsOrCombo && productsList && (
            <>
              <ProductsListResult productsList={productsList} />

              <Box mt="20">
                <Pagination
                  pageLimit={1}
                  pageNeighbours={2}
                  totalRecords={productsPagination?.total_pages}
                  currentPageSelected={pageSelected}
                  onPageChanged={(pageObject) =>
                    fetchNewPage(pageObject.currentPage)
                  }
                />
              </Box>
            </>
          )}
        </div>
      )}

      {(runningIA || isAddingProducts) && (
        <div className="overlay-progress-ia">
          <div className="progress">
            <Loader size={40} color="var(--color-purple)" />
            {runningIA ? (
              <p>Processando com IA...</p>
            ) : (
              <p>Adicionando produtos...</p>
            )}
          </div>
        </div>
      )}

      <ModalProductsErrorIA
        failedProducts={failedProductsOnAdd}
        opened={modalProductsFailed}
        setOpened={setModalProductsFailed}
      />

      <ModalUploadFilesIA
        closeModal={() => setOpenModalIA(false)}
        isOpen={openModalIA}
        onUploadFiles={handleAddProductsFromFile}
      />

      <ModalProductsWarning
        closeModal={closeModal}
        modal={modal}
        handleChangePartner={handleChangePartner}
        cancelAddProduct={cancelAddProduct}
        proceedAddProduct={proceedAddProduct}
        preparation={preparation}
        partnerSelected={partnerSelected}
        partnersOptions={partnersOptions}
        handleConfirmPartnerSelection={handleConfirmPartnerSelection}
        loadingCart={loadingCart}
      />
    </div>
  );
};
